import { render, staticRenderFns } from "./DeliveryStageTypeBadge.vue?vue&type=template&id=6557c15a&"
import script from "./DeliveryStageTypeBadge.vue?vue&type=script&lang=js&"
export * from "./DeliveryStageTypeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBadge,QTooltip});
